/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error_code: NonNullable<unknown> }} Dialog_General_Error_ContentInputs */

const en_dialog_general_error_content = /** @type {(inputs: Dialog_General_Error_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Please try again later or contact customer service. Error code: ${i?.error_code}`)
};

const ar_dialog_general_error_content = /** @type {(inputs: Dialog_General_Error_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`يرجى المحاولة مرة أخرى لاحقًا أو التواصل مع خدمة العملاء. كود الخطأ: ${i?.error_code}`)
};

const de_dialog_general_error_content = /** @type {(inputs: Dialog_General_Error_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bitte versuchen Sie es später noch einmal oder wenden Sie sich an den Kundendienst. Fehlercode: ${i?.error_code}`)
};

const es_dialog_general_error_content = /** @type {(inputs: Dialog_General_Error_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inténtalo de nuevo más tarde o ponte en contacto con el servicio de atención al cliente. Código de error: ${i?.error_code}`)
};

const fr_dialog_general_error_content = /** @type {(inputs: Dialog_General_Error_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Veuillez réessayer plus tard ou contacter le service client. Erreur : ${i?.error_code}`)
};

const it_dialog_general_error_content = /** @type {(inputs: Dialog_General_Error_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Riprova più tardi o contatta il servizio clienti. Codice di errore: ${i?.error_code}`)
};

const ja_dialog_general_error_content = /** @type {(inputs: Dialog_General_Error_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`しばらくしてからもう一度お試しいただくか、カスタマーサービスにお問い合わせください。エラーコード：${i?.error_code}`)
};

const ko_dialog_general_error_content = /** @type {(inputs: Dialog_General_Error_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`나중에 다시 시도하거나 고객센터로 문의하세요. 오류 코드: ${i?.error_code}`)
};

const pt_br_dialog_general_error_content = /** @type {(inputs: Dialog_General_Error_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tente novamente mais tarde ou contate o atendimento ao cliente. Código de erro: ${i?.error_code}`)
};

const ru_dialog_general_error_content = /** @type {(inputs: Dialog_General_Error_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Повторите попытку позже или обратитесь в службу поддержки клиентов. Код ошибки: ${i?.error_code}`)
};

const th_dialog_general_error_content = /** @type {(inputs: Dialog_General_Error_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`โปรดลองอีกครั้งในภายหลังหรือติดต่อฝ่ายบริการลูกค้า รหัสข้อผิดพลาด: ${i?.error_code}`)
};

const tr_dialog_general_error_content = /** @type {(inputs: Dialog_General_Error_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Lütfen daha sonra tekrar dene veya müşteri hizmetleriyle iletişime geç. Hata kodu: ${i?.error_code}`)
};

const zh_cn_dialog_general_error_content = /** @type {(inputs: Dialog_General_Error_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`请稍后再试一次，若问题持续发生，请回到 App 联系客服，错误码： ${i?.error_code}`)
};

const zh_tw_dialog_general_error_content = /** @type {(inputs: Dialog_General_Error_ContentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`請稍後再試一次，若問題持續發生，請回到 App 聯繫客服，錯誤碼： ${i?.error_code}`)
};

/**
* | output |
* | --- |
* | "Please try again later or contact customer service. Error code: {error_code}" |
*
* @param {Dialog_General_Error_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const dialog_general_error_content = /** @type {((inputs: Dialog_General_Error_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_General_Error_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dialog_general_error_content(inputs)
	if (locale === "ar") return ar_dialog_general_error_content(inputs)
	if (locale === "de") return de_dialog_general_error_content(inputs)
	if (locale === "es") return es_dialog_general_error_content(inputs)
	if (locale === "fr") return fr_dialog_general_error_content(inputs)
	if (locale === "it") return it_dialog_general_error_content(inputs)
	if (locale === "ja") return ja_dialog_general_error_content(inputs)
	if (locale === "ko") return ko_dialog_general_error_content(inputs)
	if (locale === "pt_br") return pt_br_dialog_general_error_content(inputs)
	if (locale === "ru") return ru_dialog_general_error_content(inputs)
	if (locale === "th") return th_dialog_general_error_content(inputs)
	if (locale === "tr") return tr_dialog_general_error_content(inputs)
	if (locale === "zh_cn") return zh_cn_dialog_general_error_content(inputs)
	return zh_tw_dialog_general_error_content(inputs)
});